import React, { FC } from 'react';

import { Tabs } from 'antd';

import AccrualsTab from './tabs/AccrualsTab';
import CommonInfoTab from './tabs/CommonInfoTab';
import PaymentsTab from './tabs/PaymentsTab';
import ReferralsTab from './tabs/ReferralsTab';


const PartnerPage: FC = () => {

    const tabs = () => [
        { label: <span data-help-id="partner-info">Общая информация</span>, key: 'item-1', children: <CommonInfoTab />, forceRender: true },
        { label: <span data-help-id="partner-referrals">Рефералы</span>, key: 'item-2', children: <ReferralsTab />, forceRender: true },
        { label: <span data-help-id="partner-accruals">Начисления</span>, key: 'item-3', children: <AccrualsTab />, forceRender: true },
        { label: <span data-help-id="partner-payments">Выплаты</span>, key: 'item-4', children: <PaymentsTab />, forceRender: true },
        { label: <span data-help-id="partner-creatives">Рекламные креативы</span>, key: 'item-5', children: <h1>Скоро добавим информацию</h1>, forceRender: true },
    ];

    return (
        <div data-help-id="partner-page">
            <Tabs
                type="card"
                items={tabs()}
            />
        </div>
    );
};

export default PartnerPage;
